/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MotorcycleInputs */

const en_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorcycle`)
};

const es_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motocicleta`)
};

const fr_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moto`)
};

const de_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motorrad`)
};

const ja_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オートバイ`)
};

const zh_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩托车`)
};

const ar_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دراجة نارية`)
};

const id_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepeda Motor`)
};

const it_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moto`)
};

const ru_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мотоцикл`)
};

const pt_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moto`)
};

const ko_val_motorcycle = /** @type {(inputs: Val_MotorcycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오토바이`)
};

/**
* | output |
* | --- |
* | "Motorcycle" |
*
* @param {Val_MotorcycleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_motorcycle = /** @type {((inputs?: Val_MotorcycleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MotorcycleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_motorcycle(inputs)
	if (locale === "es") return es_val_motorcycle(inputs)
	if (locale === "fr") return fr_val_motorcycle(inputs)
	if (locale === "de") return de_val_motorcycle(inputs)
	if (locale === "ja") return ja_val_motorcycle(inputs)
	if (locale === "zh") return zh_val_motorcycle(inputs)
	if (locale === "ar") return ar_val_motorcycle(inputs)
	if (locale === "id") return id_val_motorcycle(inputs)
	if (locale === "it") return it_val_motorcycle(inputs)
	if (locale === "ru") return ru_val_motorcycle(inputs)
	if (locale === "pt") return pt_val_motorcycle(inputs)
	return ko_val_motorcycle(inputs)
});